<div class="container-fluid" *ngIf="!isEditar && !isAgregar">
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
              <a href="#/panel-admin" class="btn btn-primary">
                Volver
              </a>
            </div>
            <h3 class="page-title">Usuarios | Institucionales</h3>
        </div>
    </div>
  </div>

  <!-- Invoice Logo-->
  <div class="row">
    <div class="col-md-2">
      <label for="busca" class="col-form-label">Bucar personal</label>
      <input
        class="form-control"
        type="text"
        id="buscar"
        placeholder="Buscar..."
        [(ngModel)]="searchTerm"
        (input)="buscar()"
      >
    </div>
    <div class="col-md-4">
      <label for="rol" class="col-form-label">Rol Institucional</label>
      <select class="form-select" id="rol" name="rol" (change)="consulta_combos()">
        <option *ngFor="let rl of roles" [value]="rl.id_rol" [selected]="rl.id_rol == sel_rol ? true : false">
          {{rl.nombre}}
        </option>
      </select>
    </div>
    <div class="col-md-4">
      <label for="estadol" class="col-form-label">Estado</label>
      <select class="form-select" id="estado" name="estado" (change)="consulta_combos()">
        <option *ngFor="let ed of estado" [value]="ed.id_estado" [selected]="ed.id_estado == sel_edo ? true : false">
          {{ed.nombre}}
        </option>
      </select>
    </div>
    <div class="col-md-2">
      <a class="btn btn-primary" style="margin-top: 37px;" (click)="agregar()">Agregar</a>
    </div>
  </div>
  <hr class="text-dark">

  <!-- end page title -->

  <div class="row">
    <div class="col-12">
      <table class="table">
        <thead>
          <tr class="table-primary">
            <th scope="col">N°</th>
            <th scope="col">Cedula</th>
            <th scope="col">Nombre(s) y Apellido(s)</th>
            <th scope="col">Rol</th>
            <th scope="col">Estados</th>
            <th scope="col">Estatus</th>
            <th scope="col">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of filteredResultado; let i = index">
            <th scope="row">{{i+1}}</th>
            <td>{{r.identificacion}}</td>
            <td>{{r.nombre_full}}</td>
            <td>{{r.rol}}</td>
            <td>{{r.estado}}</td>
            <td>
              <input class="form-check-input" type="checkbox" id={{r.id_institucional}} value={{r.id_institucional}} name="perfil"  [checked]="r.valido === true" >
            </td>
            <td>
              <a style="cursor: pointer;" class="btn btn-sm btn-primary" (click)="editar(r.id_institucional, r.nombre_full, r.identificacion)">Editar</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>


</div>

<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>

<app-agregar *ngIf="isAgregar" [id_rol]="sel_rol" (vuelve)="volver($event)"></app-agregar>

<app-editar *ngIf="isEditar"
[id_institucional]="id_institucional_envio"
[id_rol]="sel_rol"
[nombre_institucional]="nombre_institucional_envio"
(vuelve)="volver($event)"
></app-editar>
